module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('ul', {
    staticClass: "forum-post-result-list"
  }, _vm._l((_vm.posts), function(post) {
    return _c('li', {
      key: post.id
    }, [_c('ForumPostResult', {
      attrs: {
        "post": post,
        "thread": post.thread
      }
    })], 1)
  }))
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-0f0691d9!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/reusable/forum/post-result-list.vue
// module id = 1954
// module chunks = 2